import {AssetCodeTypes} from "../../../components/menus/constants";
import {MenuPlatform} from "./menuPlatformFilter";

/** 자산항목관리(CustomCode) 사이드바 — 자산그룹·업무그룹·위치관리 */
export const ASSET_ITEM_GROUP_CODE_CATEGORIES = [
    {
        id: "assetGroup",
        label: "자산그룹",
        title: "자산그룹",
        description: "자산 분류에 사용하는 그룹 코드를 관리합니다.",
        route: "/settings/code/asset/group",
        kind: "asset",
        assetCodeType: AssetCodeTypes.ASSET_CODE_GROUP,
        addLabel: "자산그룹",
        platform: MenuPlatform.ASSET,
    },
    {
        id: "taskGroup",
        label: "업무그룹",
        title: "업무그룹",
        description: "업무 분류에 사용하는 그룹 코드를 관리합니다.",
        route: "/settings/code/asset/task",
        kind: "asset",
        assetCodeType: AssetCodeTypes.ASSET_CODE_TASK,
        addLabel: "업무그룹",
        platform: MenuPlatform.ASSET,
    },
    {
        id: "location",
        label: "위치관리",
        title: "위치관리",
        description: "자산 위치 분류 코드와 도면 파일을 관리합니다.",
        route: "/settings/code/location",
        kind: "asset",
        assetCodeType: AssetCodeTypes.ASSET_LOCATION_CODE,
        addLabel: "위치",
        platform: MenuPlatform.ASSET,
    },
    {
        id: "slaGroup",
        label: "SLA 그룹",
        title: "SLA 그룹",
        description: "SLA 평가에 사용하는 그룹 코드를 관리합니다.",
        route: "/settings/code/sla-group",
        kind: "asset",
        assetCodeType: AssetCodeTypes.ASSET_SLA_GROUP_CODE,
        addLabel: "SLA 그룹",
        supportsChildCodes: false,
        platform: MenuPlatform.ITM,
    },
];

export const ASSET_ITEM_GROUP_CODE_CATEGORY_IDS = new Set(
    ASSET_ITEM_GROUP_CODE_CATEGORIES.map((item) => item.id),
);

export const ASSET_ITEM_GROUP_CODE_ROUTE_CATEGORY = Object.fromEntries(
    ASSET_ITEM_GROUP_CODE_CATEGORIES.map((item) => [item.route, item.id]),
);

/** 그룹코드 관리(GroupCodeManage) 사이드바 */
export const GROUP_CODE_MANAGE_CATEGORIES = [
    {
        id: "incidentType",
        label: "장애유형",
        title: "장애유형",
        description: "장애 요청 분류에 사용하는 유형 코드를 관리합니다.",
        route: "/settings/maintenance/incident/code",
        kind: "asset",
        assetCodeType: AssetCodeTypes.INCIDENT_CODE,
        addLabel: "장애유형",
        nameLabel: "장애유형",
        supportsApprovalLines: true,
        platform: MenuPlatform.ITM,
    },
    {
        id: "workType",
        label: "작업유형",
        title: "작업유형",
        description: "작업 요청 분류에 사용하는 유형 코드를 관리합니다.",
        route: "/settings/maintenance/work/code",
        kind: "asset",
        assetCodeType: AssetCodeTypes.WORK_CODE,
        addLabel: "작업유형",
        nameLabel: "작업유형",
        supportsApprovalLines: true,
        platform: MenuPlatform.ITM,
    },
    {
        id: "inspectionType",
        label: "점검종류",
        title: "점검종류",
        description: "점검 요청 분류에 사용하는 종류 코드를 관리합니다.",
        route: "/settings/maintenance/inspection/code",
        kind: "asset",
        assetCodeType: AssetCodeTypes.INSPECTION_CODE,
        addLabel: "점검종류",
        nameLabel: "점검종류",
        supportsApprovalLines: true,
        platform: MenuPlatform.ITM,
    },
    {
        id: "serviceRequest",
        label: "서비스요청그룹",
        title: "서비스요청그룹",
        description: "서비스 요청 분류 코드와 처리담당자를 관리합니다.",
        route: "/settings/code/service/group",
        kind: "service",
        addLabel: "서비스요청그룹",
        platform: MenuPlatform.SRM,
    },
    {
        id: "rentalGroup",
        label: "대여그룹",
        title: "대여그룹",
        description: "대여 자산 분류에 사용하는 그룹 코드를 관리합니다.",
        route: "/settings/lifecycle/rental/code",
        kind: "asset",
        assetCodeType: AssetCodeTypes.RENTAL_ASSET_CODE,
        addLabel: "대여그룹",
        nameLabel: "대여그룹 코드명",
        platform: MenuPlatform.IAM,
    },
    {
        id: "introduction",
        label: "자산도입",
        title: "자산도입",
        description: "자산 도입 요청 분류에 사용하는 코드를 관리합니다.",
        route: "/settings/lifecycle/introduction/code",
        kind: "asset",
        assetCodeType: AssetCodeTypes.INTRODUCTION_CODE,
        addLabel: "자산도입",
        nameLabel: "도입코드명",
        supportsApprovalBeforeOnly: true,
        platform: MenuPlatform.IAM,
    },
    {
        id: "dispose",
        label: "자산폐기",
        title: "자산폐기",
        description: "자산 폐기 요청 분류에 사용하는 코드를 관리합니다.",
        route: "/settings/lifecycle/dispose/code",
        kind: "asset",
        assetCodeType: AssetCodeTypes.DISPOSE_CODE,
        addLabel: "자산폐기",
        nameLabel: "폐기코드명",
        supportsApprovalBeforeOnly: true,
        platform: MenuPlatform.IAM,
    },
    {
        id: "diligence",
        label: "실사관리",
        title: "실사관리",
        description: "자산 실사 분류에 사용하는 코드를 관리합니다.",
        route: "/settings/code/diligence",
        kind: "asset",
        assetCodeType: AssetCodeTypes.DILIGENCE_CODE,
        addLabel: "실사",
        nameLabel: "실사코드명",
        platform: MenuPlatform.IAM,
    },
    {
        id: "assetMemo",
        label: "자산기록관리",
        title: "자산기록관리",
        description: "자산 기록 분류에 사용하는 코드를 관리합니다.",
        route: "/settings/code/memo",
        kind: "asset",
        assetCodeType: AssetCodeTypes.ASSET_MEMO_CODE,
        addLabel: "자산기록",
        nameLabel: "자산기록 코드명",
        platform: MenuPlatform.IAM,
    },
    {
        id: "purchase",
        label: "구매관리",
        title: "구매관리",
        description: "자산 구매 시 공급 방법·구분 분류 코드를 관리합니다.",
        route: "/settings/code/purchase",
        kind: "purchase",
        platform: MenuPlatform.ASSET,
        variants: {
            method: {
                assetCodeType: AssetCodeTypes.PURCHASE_CODE_GROUP,
                addLabel: "구매방법",
                nameLabel: "구매관리(방법)명",
            },
            category: {
                assetCodeType: AssetCodeTypes.PURCHASE_CODE_GROUP_CATEGORY,
                addLabel: "구매구분",
                nameLabel: "구매관리(구분)명",
            },
        },
    },
];

export const PURCHASE_SUB_NAV = [
    {id: "method", label: "방법"},
    {id: "category", label: "구분"},
];

export const PURCHASE_ROUTE_SUB_NAV = {
    "/settings/code/purchase": "method",
    "/settings/code/purchase2": "category",
};

export function resolveGroupCodeCategoryMeta(category, purchaseSubNav = "method") {
    if (!category || category.kind !== "purchase") {
        return category;
    }

    const variant = category.variants[purchaseSubNav] ?? category.variants.method;

    return {
        ...category,
        ...variant,
        id: `${category.id}:${purchaseSubNav}`,
        kind: "asset",
    };
}

export const GROUP_CODE_MANAGE_ROUTE_CATEGORY = {
    ...Object.fromEntries(
        GROUP_CODE_MANAGE_CATEGORIES.map((item) => [item.route, item.id]),
    ),
    "/settings/code/purchase2": "purchase",
};

/** 자산항목관리(CustomCode) 사이드바 전체 */
export const CUSTOM_CODE_CATEGORIES = [
    {
        id: "commonItem",
        label: "공통 항목",
        title: "공통 항목",
        description: "자산 정보에 공통으로 사용하는 코드·텍스트 항목을 관리합니다.",
        route: "/settings/custom/common-code",
        platform: MenuPlatform.ASSET,
    },
    ...ASSET_ITEM_GROUP_CODE_CATEGORIES,
    {
        id: "project",
        label: "시스템",
        title: "시스템",
        description: "시스템 구분에 사용하는 항목을 관리합니다.",
        route: "/settings/custom/project",
        platform: MenuPlatform.ASSET,
    },
    {
        id: "assetGroupItem",
        label: "자산그룹별 항목",
        title: "자산그룹별 항목",
        description: "자산 그룹별로 사용할 필드를 설정합니다.",
        route: "/settings/custom/group-field",
        platform: MenuPlatform.ASSET,
    },
    {
        id: "groupSelectOption",
        label: "Select 옵션 관리",
        title: "Select 옵션 관리",
        description: "필드에서 SELECT 선택 시 사용할 옵션과 값을 관리합니다.",
        route: "/settings/custom/group-code",
        platform: MenuPlatform.ASSET,
    },
];

export const CUSTOM_CODE_ROUTE_CATEGORY = {
    ...ASSET_ITEM_GROUP_CODE_ROUTE_CATEGORY,
    "/settings/code/asset": "assetGroup",
    "/settings/custom/project": "project",
    "/settings/custom/common-code": "commonItem",
    "/settings/custom/common-string": "commonItem",
    "/settings/custom/group-field": "assetGroup",
    "/settings/custom/group-code": "assetGroup",
};

const SIDEBAR_PRIMARY_NAV_IDS = ["commonItem", "assetGroup", "project"];

/** 사이드바에 노출할 항목 순서 (플랫폼 필터 전) */
export function buildCustomCodeSidebarNavItems(categories = CUSTOM_CODE_CATEGORIES) {
    return [
        ...SIDEBAR_PRIMARY_NAV_IDS
            .map((id) => categories.find((item) => item.id === id))
            .filter(Boolean),
        ...categories.filter(
            (item) => item.id !== "groupSelectOption"
                && item.id !== "assetGroupItem"
                && !SIDEBAR_PRIMARY_NAV_IDS.includes(item.id),
        ),
    ];
}

export function isAssetItemGroupCodeCategory(categoryId) {
    return ASSET_ITEM_GROUP_CODE_CATEGORY_IDS.has(categoryId);
}
